import PropTypes from 'prop-types';
import styles from './ClearFilters.module.scss';
import clearFiltersIcon from 'assets/images/clear-filters-icon.svg';

const ClearFilters = (props) => {
    const { style, onClick } = props;
    return (
        <div
            className={styles.clearFiltersWrapper}
            style={style}
            onClick={onClick}
        >
            <img
                src={clearFiltersIcon}
                alt=""
                className={styles.clearFiltersImg}
            />
            <span className={styles.clearFiltersText}>Clear Filters</span>
        </div>
    );
};

ClearFilters.propTypes = {
    style: PropTypes.object,
    onClick: PropTypes.func
};
export default ClearFilters;
